module.exports = __webpack_public_path__ + "static/media/Iconos_Check_Point_App_Gris-07.8fee4e25.svg";